import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { matchText } from 'modules/core/lib/stringUtils'

import type { ResultType } from 'modules/command_bar/lib/types'
import getTitle from 'modules/documents/components/Documents/getTitle'
import type { Documents } from 'modules/documents/store/collections/documents'
import type { Folders } from 'modules/documents/store/collections/folders'

export interface DocumentResults {
  search: string
  documentsCollection: Documents
  foldersCollection: Folders
}

export const useDocumentResults = ({
  search,
  documentsCollection,
  foldersCollection,
}: DocumentResults): ResultType[] => {
  const { navigation } = useNavigation()

  if (!search.length) return []

  return documentsCollection
    .filter((document) => matchText(search, document.attributes.filename))
    .map((document): ResultType => {
      const folder = foldersCollection.get(document.attributes.folder_id)
      const folderName = folder?.attributes.name
      const fileName = document.attributes.filename
      const category = i18n.t('command_bar.plugins.documents.categories.my_documents')

      const navigationPath = folder?.attributes.id
        ? navigation.documents.folderId.documentId.fullPath({
            folderId: folder?.attributes.id,
            document_id: document.attributes.id,
          })
        : navigation.documents.list.documentId.fullPath({
            document_id: document.attributes.id,
          })

      return {
        id: document.attributes.file,
        text:
          `${category} -> ` +
          (folderName ? `${getTitle(folderName)} -> ${fileName}` : `${fileName}`),
        IconComponent: () => <Icon.Medium icon="file" />,
        type: 'navigation',
        score: 2,
        navigationPath,
      }
    })
}
